var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProjectBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-project"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "project",
    clipPath: "url(#clip-project)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11158",
    "data-name": "Group 11158",
    transform: "translate(-6819.029 2865.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11120",
    "data-name": "Group 11120",
    transform: "translate(6822.772 -2862.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11213",
    "data-name": "\\u30D1\\u30B9 11213",
    d: "M1.988,44.185a1.484,1.484,0,0,1-1.009-.477,1.692,1.692,0,0,1-.434-.7.862.862,0,0,1,.181-.877L9.2,33.658a.5.5,0,1,1,.708.708L1.516,42.755a.842.842,0,0,0,.415.415l8.389-8.389a.5.5,0,1,1,.708.708L2.558,43.96A.786.786,0,0,1,1.988,44.185Z",
    transform: "translate(-0.5 -27.61)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11215",
    "data-name": "\\u30D1\\u30B9 11215",
    d: "M48.777,22.275a.5.5,0,0,1-.354-.147l-1.787-1.788a.5.5,0,0,1-.05-.649l1.931-2.648a.5.5,0,1,1,.809.59l-1.679,2.3,1.182,1.182,2.3-1.679a.5.5,0,1,1,.59.809l-2.648,1.931A.5.5,0,0,1,48.777,22.275Z",
    transform: "translate(-38.27 -13.918)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11216",
    "data-name": "\\u30D1\\u30B9 11216",
    d: "M27.767,5.607a.5.5,0,0,1-.354-.147,17.04,17.04,0,0,0-4.342-3.189A4.723,4.723,0,0,0,19.8,1.6a.5.5,0,1,1-.35-.938c1.231-.459,2.887.134,4.06.712a18.064,18.064,0,0,1,4.607,3.379.5.5,0,0,1-.354.855Z",
    transform: "translate(-15.799 -0.497)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11217",
    "data-name": "\\u30D1\\u30B9 11217",
    d: "M25.365,6.412a.5.5,0,0,1-.38-.174A16.323,16.323,0,0,0,19.428,2.19a.5.5,0,1,1,.4-.917,17.06,17.06,0,0,1,5.914,4.312.5.5,0,0,1-.379.827Z",
    transform: "translate(-15.799 -1.099)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11218",
    "data-name": "\\u30D1\\u30B9 11218",
    d: "M69.141,32.619a.5.5,0,0,1-.469-.676A4.723,4.723,0,0,0,68,28.676a17.04,17.04,0,0,0-3.189-4.342.5.5,0,0,1,.708-.708A18.064,18.064,0,0,1,68.9,28.234c.578,1.173,1.171,2.829.712,4.06A.5.5,0,0,1,69.141,32.619Z",
    transform: "translate(-53.197 -19.372)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11219",
    "data-name": "\\u30D1\\u30B9 11219",
    d: "M68.206,43.66a.5.5,0,0,1-.459-.3A16.32,16.32,0,0,0,63.7,37.8a.5.5,0,0,1,.653-.759,17.057,17.057,0,0,1,4.312,5.914.5.5,0,0,1-.458.7Z",
    transform: "translate(-52.261 -30.412)",
    fill: "#377ef3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3538",
    "data-name": "Rectangle 3538",
    width: 24,
    height: 24,
    transform: "translate(6819.029 -2865.97)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectBlue);
export default __webpack_public_path__ + "static/media/icon_project_blue.843cd751b11272ec34927d3ddfc50040.svg";
export { ForwardRef as ReactComponent };